<template lang="html">
    <section class="section-companies" id="companies">
        <div class="row">
            <h2>Companies we work with</h2>
        </div>
        <div class="row">
            <div class="col span-1-of-3">
                <div class="plan-box">
                    <div>
                        <img src="../../assets/resources/img/baocheng.jpg" alt="ihd baocheng">
                    </div>
                    <div>
                        <a href="#" class="btn btn-full" @click.prevent="showContent(0)">详情</a>
                    </div>
                </div>
            </div>
            <div class="col span-1-of-3">
                <div class="plan-box">
                    <div>
                        <img src="../../assets/resources/img/bea.jpg" alt="ihd bea">
                    </div>
                    <div>
                        <a href="#" class="btn btn-ghost" @click.prevent="showContent(1)">详情</a>
                    </div>
                </div>
            </div>
            <div class="col span-1-of-3">
                <div class="plan-box">
                    <div>
                        <img src="../../assets/resources/img/hsbc.jpg" alt="ihd hsbc">
                    </div>
                    <div>
                        <a href="#" class="btn btn-ghost" @click.prevent="showContent(2)">详情</a>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <br>
        <div class="row">
            <div class="col span-1-of-3">
                <div class="plan-box">
                    <div>
                        <img src="../../assets/resources/img/jpmorgan.jpg" alt="ihd jpmorgan">
                    </div>
                    <div>
                        <a href="#" class="btn btn-ghost" @click.prevent="showContent(3)">详情</a>
                    </div>
                </div>
            </div>
            <div class="col span-1-of-3">
                <div class="plan-box">
                    <div>
                        <img src="../../assets/resources/img/pwc.jpg" alt="ihd pwc">
                    </div>
                    <div>
                        <a href="#" class="btn btn-ghost" @click.prevent="showContent(4)">详情</a>
                    </div>
                </div>
            </div>
            <div class="col span-1-of-3">
                <div class="plan-box">
                    <div>
                        <img src="../../assets/resources/img/zhongxin.jpg" alt="ihd zhongxin">
                    </div>
                    <div>
                        <a href="#" class="btn btn-ghost" @click.prevent="showContent(5)">详情</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- company content popup -->
        <new-content></new-content>

        <!-- <button @click="showContent">Show</button>
        <span>{{ $store.getters.contentShow }}</span> -->
        <!-- waypoint handler functions -->
        <v-waypoint
        @waypoint-in="$store.dispatch('updateSticky')"
        @waypoint-out="$store.dispatch('updateSticky')"
        ></v-waypoint>
    </section>
</template>

<script>
import NewContent from '../modal/NewContent.vue';
import company_info from '../../data/companyinfo.js';


export default {
    methods: {
        showContent(ref) {
            this.$store.dispatch('updateCompanyContent', company_info[ref]);
            this.$store.dispatch('updateContentShow', true);
            console.log(company_info[ref]);
        }
    },
    components: {
        NewContent
    }
}
</script>

<style lang="scss">
@import "../../assets/resources/css/partials/variables";

.plan-box {
    background-color: #fff;
    border-radius: 5px;
    width: 90%;
    margin-left: 5%;
    box-shadow: 0 2px 2px #efefef;

    div {
        padding: 15px;
        border-bottom: 1px solid #e8e8e8;

        img {
            width: 100%;
            height: 105%;

            @media only screen and (max-width: $medium-screen) {
                width: 50%;
                margin-left: 25%;
            }
        }

        &:first-child {
            background-color: #fcfcfc;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            height: 200px;
        }

        &:last-child {
            text-align: center;
            border: 0;
        }
    }
}

.plan-price-meal {
    font-size: 80%;
}

.plan-box p {
    padding: 10px;
    text-align: left;
}

</style>



// WEBPACK FOOTER //
// Companies.vue?12de096e